module.exports = __webpack_public_path__ + "img/quotemark.9218d16a.png";